import React from 'react'
import { TopToolbarProps } from './types'
import {
  ToolbarContainer,
  LeftSection,
  CenterSection,
  RightSection,
  BackButton,
  MapTitle,
  SaveStatus,
  Button,
  Divider,
} from './styled'

const TopToolbar: React.FC<TopToolbarProps> = ({
  mapName,
  hasUnsavedChanges,
  isOwner,
  onSave,
  onShare,
  onBranding,
  onEmbed,
  onBack,
  onEditSettings,
  showingSettings,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
}) => {
  return (
    <ToolbarContainer>
      <LeftSection>
        <BackButton onClick={onBack}>← Back to Dashboard</BackButton>
        <Divider />
        <MapTitle>{mapName}</MapTitle>
      </LeftSection>

      <CenterSection>
        {onUndo && onRedo && (
          <>
            <Button
              onClick={onUndo}
              disabled={!canUndo}
              title="Undo (Ctrl+Z)"
              style={{
                opacity: canUndo ? 1 : 0.5,
                cursor: canUndo ? 'pointer' : 'not-allowed',
                marginRight: '8px'
              }}
            >
              ↶ Undo
            </Button>
            <Button
              onClick={onRedo}
              disabled={!canRedo}
              title="Redo (Ctrl+Y)"
              style={{
                opacity: canRedo ? 1 : 0.5,
                cursor: canRedo ? 'pointer' : 'not-allowed',
                marginRight: '16px'
              }}
            >
              ↷ Redo
            </Button>
          </>
        )}
        <SaveStatus $hasChanges={hasUnsavedChanges}>
          {hasUnsavedChanges ? 'Unsaved changes' : 'All changes saved'}
        </SaveStatus>
      </CenterSection>

      <RightSection>
        <Button
          onClick={onEditSettings}
          $variant={showingSettings ? 'primary' : 'secondary'}>
          Edit Floorplan Settings
        </Button>
        <Divider />
        {isOwner && (
          <>
            <Button onClick={onBranding}>Branding</Button>
            <Divider />
            <Button onClick={onShare}>Share</Button>
            <Divider />
            {onEmbed && (
              <>
                <Button onClick={onEmbed}>📎 Embed</Button>
                <Divider />
              </>
            )}
          </>
        )}
        <Button
          $variant="primary"
          onClick={onSave}
          disabled={!hasUnsavedChanges}>
          Save
        </Button>
      </RightSection>
    </ToolbarContainer>
  )
}

export { TopToolbar }
